@use "stylesheets/utility/variables";
.resetForm {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 12px;
}

.formGroup {
  label {
    font-weight: 700;
  }
}

.activateAccount {
  text-align: center;
}
